import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import { standardAuthentication } from './security/keycloak';
import { Spinner } from './spinner/Spinner';

ReactDOM.render(
  <Spinner/>,
  document.getElementById('root') as HTMLElement
);

standardAuthentication().then(
  () => {
    ReactDOM.render(
      <App />,
      document.getElementById('root') as HTMLElement
    );

  }
);
